import { computed, signal } from "@preact/signals-react";

export const skip = signal(0);
export const take = signal(4);
export const buttonCount = signal(5);
export const type = signal("numeric");
export const info = signal(true);
export const pageSizes = signal(true);
export const previousNext = signal(true);
export const responsive = signal(true);
export const isDeleting = signal({});
export const showDeleteDialog = signal(false);
export const showInUseDialog = signal(false);
export const inUseTemplate = signal(null);
export const selectedDatasetId = signal(null);
export const viewPerms = signal({});
export const search = signal("");

export const pageState = computed(() => {
  return {
    skip: skip.value,
    take: take.value,
    buttonCount: buttonCount.value,
    type: type.value,
    info: info.value,
    pageSizes: pageSizes.value,
    previousNext: previousNext.value,
    responsive: responsive.value,
  };
});
